import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import axios from 'axios';
import { Grid, TextField, Button, Box, Typography } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import DeleteIcon from '@mui/icons-material/Delete'
import DialogTitle from '@mui/material/DialogTitle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ClearIcon from '@mui/icons-material/Clear';
import Swal from 'sweetalert2';
import Headroom from "react-headroom";

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  nodesvalues: Yup.string().required('value is required'),
});

const MyForm = (props) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema)
  });
  const token = localStorage.getItem("Token")
  const [refresh, setRefresh] = useState(false);
  const [submitting, setSubmitting] = useState(false)

 

  const parentId = props.parentId
  const nodeId = props.nodeId
  const onSubmit = async (data) => {
    try {
      const postData = {
        ...data,
        name: data.name || props.name,
        id: nodeId,
        description: data.description || "default description",
        createdBy: '', // Placeholder; adjust if needed
        updatedBy: '', // Placeholder; adjust if needed
        isActive: props.isActive,
        defaultpracticeId: props.defaultpracticeId,
        value: data.nodesvalues !== undefined ? data.nodesvalues : props.nodesvalues,
        parentId: parentId,
        children: []
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Module/AddModules`,
        [postData],
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      // Handle successful response
      props.applyRefresh();
      if (typeof props.handleClose === 'function') {
        props.handleClose();
      }

      // Show success popup
      Swal.fire({
        title: 'Record Added',
        text: 'Record added successfully',
        icon: 'success',
        timer: 1000,
      });

    } catch (error) {
      // Handle errors
      console.error('Submission failed:', error);

      // Show error popup
      Swal.fire({
        title: 'Error',
        text: 'There was an error adding the record.',
        icon: 'error',
      });

    } finally {
      // Optional: Any final operations if needed
      // Example: Reset state, close loading spinner, etc.
    }
  };

  const onSubmitUpdate = async (data) => {
    try {
      const postData = {
        ...data,
        name: data.name || props.name,
        id: nodeId,
        defaultpracticeId: localStorage.getItem('default_paractice'),
        values: data.nodesvalues !== undefined ? data.nodesvalues : props.nodesvalues,
        parentId: parentId,
        description: data.description || "default description",
        createdBy: '', // Placeholder; adjust if needed
        updatedBy: '', // Placeholder; adjust if needed
        isActive: props.isActive,
        value: data.nodesvalues !== undefined ? data.nodesvalues : props.nodesvalues,
        children: []
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Module/AddModules`,
        [postData],
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      // Handle successful response
      props.applyRefresh();
      if (typeof props.handleClose === 'function') {
        props.handleClose();
      }

      // Show success popup
      Swal.fire({
        title: 'Record Updated',
        text: 'Record updated successfully',
        icon: 'success',
        timer: 1000,
      });

    } catch (error) {
      // Handle errors
      console.error('Submission failed:', error);

      // Show error popup
      Swal.fire({
        title: 'Error',
        text: 'There was an error updating the record.',
        icon: 'error',
      });

    } finally {
      // Any final operations if needed
      // Example: Reset state, close loading spinner, etc.
    }
  };
   const onDelete = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      didOpen: () => {
        // Apply inline z-index to force Swal on top
        const swalContainer = document.querySelector('.swal2-container');
        if (swalContainer) {
          swalContainer.style.zIndex = '9999';
        }
      }
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(
          `${process.env.REACT_APP_API_URL}/Module/DeleteModules?id=${nodeId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          console.log('Submission successful:', response.data);
          setRefresh(!refresh);
          props.applyRefresh();
  
          Swal.fire({
            title: 'Record Deleted',
            text: 'Record deleted successfully',
            icon: 'success',
            timer: 1000,
            didOpen: () => {
              const swalContainer = document.querySelector('.swal2-container');
              if (swalContainer) {
                swalContainer.style.zIndex = '9999';
              }
            }
          });
  
          if (typeof props.handleClose === 'function') {
            props.handleClose();
          }
        })
        .catch((error) => {
          console.error('Submission failed:', error);
  
          Swal.fire({
            title: 'Error',
            text: 'There was an error deleting the record.',
            icon: 'error',
            didOpen: () => {
              const swalContainer = document.querySelector('.swal2-container');
              if (swalContainer) {
                swalContainer.style.zIndex = '9999';
              }
            }
          });
        });
      } else {
        console.log('User cancelled deletion');
      }
    });
  };
  return (
    <>
      <Grid item xs={12} sm={12} xl={12}  >
        <Headroom>
          <Grid
            container
            style={{ backgroundColor: '#356F60', position: 'sticky' }}
          >
            <Grid item xs={12} sm={12} xl={12}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '100%'
                }}
              >
                <DialogTitle
                  style={{
                    flex: 1,
                    textAlign: 'center',
                  }}
                >
                  <h1
                    style={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      color: '#fff',
                      // textDecoration: 'underline',
                      fontSize: '1.3rem'

                    }}
                  >
                    {props.update ? 'Update Modules' : 'New Modules'}
                  </h1>
                </DialogTitle>
                <CancelOutlinedIcon
                  onClick={() => props.handleClose()}
                  fontSize="large"
                  color="red"
                  style={{
                    color: 'red',
                    paddingRight: '5px',
                    cursor: 'pointer',
                    float: 'right'
                  }}
                ></CancelOutlinedIcon>

              </div>
            </Grid>
          </Grid>
        </Headroom>
      </Grid>
      <Grid container spacing={2} style={{ padding: '10px' }}>
        <Grid item xs={12} sm={6}>
          <Box mb={2}>
            <label htmlFor="name">Name</label>
            <Controller
              name="name"
              control={control}

              defaultValue={props.name || ''}
              render={({ field }) => (
                <TextField id="name" size="small" fullWidth {...field} error={Boolean(errors.name)} helperText={errors.name ? 'Name is required' : ''} />
              )}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box mb={2}>
            <label htmlFor="nodesvalues">Value</label>
            <Controller
              name="nodesvalues"
              control={control}
              defaultValue={props.nodesvalues || ''}

              render={({ field }) => (
                <TextField
                  id="nodesvalues"
                  fullWidth
                  {...field}
                  size="small"
                  value={field.value}
                  placeholder={props.nodesvalues === 'string' ? 'Enter value' : props.nodesvalues}
                  error={Boolean(errors.nodesvalues)}
                  helperText={errors.nodesvalues ? 'Value is required' : ''}
                />
              )}
            />

          </Box>
        </Grid>
        <Grid container alignItems="center">
          <Grid item xs={props.update ? 2 : 5}></Grid>
          <Grid item xs={3}>
            <Button
              onClick={() => props.handleClose()}
              className="Button"
              style={{
                marginBottom: '10px',
                float: 'right',
                marginLeft: '20px',
                width: '120px',
                height: '35px',
                // backgroundColor: '#A574FD',
                color: 'white',
                fontSize: '14px'
              }}
            >
              <ClearIcon
                fontSize='medium'
                style={{
                  color: 'white',
                  marginRight: '1px',
                  paddingRight: '0px',
                  paddingBottom: '2px',

                }}
              ></ClearIcon>
              Cancel
            </Button>
          </Grid>


          {props.update ? (
            <>
              <Grid item xs={0.5}></Grid>

              <Grid item xs={3}>
                <Button
                  type="submit"
                  className="Button"
                  style={{
                    marginBottom: '10px',
                    float: 'right',
                    marginLeft: '20px',
                    width: '120px',
                    height: '35px',
                    // backgroundColor: '#A574FD',
                    color: 'white',
                    fontSize: '14px'
                  }}
                  onClick={handleSubmit(onSubmitUpdate)}
                >
                  <SaveOutlinedIcon
                    fontSize='medium'
                    style={{
                      color: 'white',
                      marginRight: '1px',
                      paddingRight: '0px',
                      paddingBottom: '2px',

                    }}
                  />Update
                </Button>
              </Grid>
              <Grid item xs={0.5}></Grid>

              <Grid item xs={3}>
                <Button
                 onClick={onDelete}
                  style={{
                    marginBottom: '10px',
                    float: 'right',
                    marginLeft: '20px',
                    width: '120px',
                    height: '35px',
                    backgroundColor: 'red',
                    color: 'white',
                    fontSize: '14px'
                  }}
                >
                  <DeleteIcon fontSize='medium'
                    style={{
                      color: 'white',
                      marginRight: '1px',
                      paddingRight: '0px',
                      paddingBottom: '2px',

                    }}
                  />
                  Delete
                </Button>
              </Grid>
            </>

          ) : (<>
            <Grid item xs={0.5}></Grid>

            <Grid item xs={3}>
              <Button
                className="Button"
                style={{
                  marginBottom: '10px',
                  float: 'right',
                  marginLeft: '20px',
                  width: '120px',
                  height: '35px',
                  // backgroundColor: '#A574FD',
                  color: 'white',
                  fontSize: '14px'
                }}
                onClick={handleSubmit(onSubmit)}
              >
                <SaveOutlinedIcon
                  fontSize='medium'
                  style={{
                    color: 'white',
                    marginRight: '1px',
                    paddingRight: '0px',
                    paddingBottom: '2px',

                  }}
                />
                SAVE
              </Button>
            </Grid>
          </>
          )}





        </Grid>


      </Grid>
    </>

  );
};

export default MyForm;
